declare namespace $ {

	type $mol_view__sub_bog_music_account_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_switch__value_bog_music_account_2 = $mol_type_enforce<
		ReturnType< $bog_music_account['font_size'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_music_account_3 = $mol_type_enforce<
		({ 
			'normal': string,
			'large': string,
			'huge': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_view__sub_bog_music_account_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_bog_music_account_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_music_account_6 = $mol_type_enforce<
		ReturnType< $bog_music_account['dev'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_bog_music_account_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_music_account_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_account_9 = $mol_type_enforce<
		ReturnType< $bog_music_account['download_playlist'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_account_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_account_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_bog_music_account_13 = $mol_type_enforce<
		ReturnType< $bog_music_account['nickname'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_music_account_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_music_account_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_music_account_16 = $mol_type_enforce<
		ReturnType< $bog_music_account['Nickname_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_view__sub_bog_music_account_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_account_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_music_account_21 = $mol_type_enforce<
		ReturnType< $bog_music_account['tg_hint'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_music_account_22 = $mol_type_enforce<
		ReturnType< $bog_music_account['tg_button'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_account_23 = $mol_type_enforce<
		ReturnType< $bog_music_account['tg_link'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_account_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_account_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_music_account_27 = $mol_type_enforce<
		ReturnType< $bog_music_account['fm_hint'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_music_account_28 = $mol_type_enforce<
		ReturnType< $bog_music_account['fm_button'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_account_29 = $mol_type_enforce<
		ReturnType< $bog_music_account['fm_link'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_account_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_account_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_music_account_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_account_34 = $mol_type_enforce<
		ReturnType< $bog_music_account['copy'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_account_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__title_bog_music_account_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_music_account_37 = $mol_type_enforce<
		ReturnType< $bog_music_account['qr_showed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $bog_qr__uri_bog_music_account_38 = $mol_type_enforce<
		ReturnType< $bog_music_account['account_link'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $bog_qr__error_correction_bog_music_account_39 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_qr['error_correction'] >
	>
	type $bog_qr__gradient_stops_bog_music_account_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_qr['gradient_stops'] >
	>
	type $mol_view__sub_bog_music_account_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_account_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_string__hint_bog_music_account_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_music_account_44 = $mol_type_enforce<
		ReturnType< $bog_music_account['import_link'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__title_bog_music_account_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_account_46 = $mol_type_enforce<
		ReturnType< $bog_music_account['apply_import'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $bog_music_qrscan__prefix_bog_music_account_47 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_qrscan['prefix'] >
	>
	type $bog_music_qrscan__found_bog_music_account_48 = $mol_type_enforce<
		ReturnType< $bog_music_account['qr_found'] >
		,
		ReturnType< $bog_music_qrscan['found'] >
	>
	type $mol_view__sub_bog_music_account_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_account_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_music_account_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_account_53 = $mol_type_enforce<
		ReturnType< $bog_music_account['reset_account'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_account_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_account_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_music_account extends $mol_view {
		Font_label( ): $mol_view
		Font_size( ): $mol_switch
		Font_row( ): $mol_view
		Dev( ): $mol_check_box
		download_playlist( next?: any ): any
		Download_playlist_icon( ): $mol_icon_download
		Download_playlist_label( ): $mol_view
		Download_playlist( ): $mol_button_minor
		download_playlist_status( ): string
		Download_playlist_status( ): $mol_view
		Sync_row( ): $mol_view
		nickname( next?: string ): string
		Nickname_input( ): $mol_string
		Nickname_field( ): $mol_form_field
		lord_text( ): string
		Lord_text( ): $mol_view
		Lord( ): $mol_view
		Profile( ): $mol_view
		Tg_title( ): $mol_paragraph
		tg_hint( ): string
		Tg_hint( ): $mol_paragraph
		tg_button( ): string
		tg_link( next?: any ): any
		Tg_connect( ): $mol_button_minor
		tg_status( ): string
		Tg_status( ): $mol_view
		Telegram( ): $mol_view
		Fm_title( ): $mol_paragraph
		fm_hint( ): string
		Fm_hint( ): $mol_paragraph
		fm_button( ): string
		fm_link( next?: any ): any
		Fm_connect( ): $mol_button_minor
		fm_status( ): string
		Fm_status( ): $mol_view
		Lastfm( ): $mol_view
		Warning( ): $mol_paragraph
		copy( next?: any ): any
		Copy( ): $mol_button_minor
		copy_status( ): string
		Copy_status( ): $mol_view
		qr_showed( next?: boolean ): boolean
		Qr_show( ): $mol_check
		account_link( ): string
		Qr( ): $bog_qr
		Export( ): $mol_view
		Import_hint( ): $mol_paragraph
		import_link( next?: string ): string
		Import_input( ): $mol_string
		apply_import( next?: any ): any
		Import_apply( ): $mol_button_minor
		qr_found( next?: string ): string
		Import_scan( ): $bog_music_qrscan
		import_status( ): string
		Import_status( ): $mol_view
		Import( ): $mol_view
		Reset_hint( ): $mol_paragraph
		reset_account( next?: any ): any
		Reset_button( ): $mol_button_minor
		Reset( ): $mol_view
		Cards( ): $mol_view
		font_size( next?: string ): string
		dev( next?: boolean ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=account.view.tree.d.ts.map